module.exports = __webpack_public_path__ + "static/media/awsblog.f50b7dc3.jpg";